import {
  TrackingEventID,
  TrackingEventPageID,
  TrackingEventType,
} from "@/shared";

const DownloadMaskLClick = {
  event_id: TrackingEventID.DownloadMaskExposure,
  event_type: TrackingEventType.Click,
};
const DownloadMaskLExposure = {
  event_id: TrackingEventID.DownloadMaskExposure,
  event_type: TrackingEventType.Exposure,
};
const ProductsToTT = {
  event_id: TrackingEventID.ProductsToTTClick,
  event_type: TrackingEventType.Click,
  page_id: TrackingEventPageID.ProductsPage,
};

const ProductsToTTDownload = {
  event_id: TrackingEventID.ProductsToTTDownload,
  event_type: TrackingEventType.Click,
  page_id: TrackingEventPageID.ProductsPage,
};

const Download = {
  event_id: TrackingEventID.ProductsDownload,
  event_type: TrackingEventType.Click,
  page_id: TrackingEventPageID.ProductsPage,
};

export const TrackingPoints = {
  DownloadMaskLClick,
  DownloadMaskLExposure,
  ProductsToTT,
  ProductsToTTDownload,
  Download,
};
